import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import * as Sentry from '@sentry/react'

import { router } from '@/app/routes'
import { AppProviders } from '@/app/providers'
import { ThemeProvider } from '@/app/providers/ThemeProvider'
import { ProjectStoreProvider } from '@/store/useProjectStore'

const SentryErrorFallback = () => (
  <div className="min-h-screen bg-[#02182B] flex items-center justify-center px-6">
    <div className="text-center space-y-4 max-w-md">
      <div className="w-12 h-12 bg-red-500/10 rounded-lg flex items-center justify-center mx-auto">
        <span className="text-red-400 text-xl">!</span>
      </div>
      <h2 className="text-white text-xl font-semibold">Something went wrong</h2>
      <p className="text-gray-400 text-sm">An unexpected error occurred. Our team has been notified.</p>
      <button
        onClick={() => window.location.href = '/'}
        className="bg-[#FD802E] text-[#233D4C] font-semibold px-6 py-3 rounded-lg hover:bg-[#ff8f45] transition-colors text-sm"
      >
        Back to home
      </button>
    </div>
  </div>
)

export const App = () => {
  return (
    <Sentry.ErrorBoundary fallback={<SentryErrorFallback />} showDialog={false}>
      <ThemeProvider>
        <AppProviders>
          <ProjectStoreProvider>
            <Suspense fallback={<div className="p-8 text-sm text-muted-foreground">Loading Searchline Engine…</div>}>
              <RouterProvider router={router} />
            </Suspense>
          </ProjectStoreProvider>
        </AppProviders>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  )
}
